// extracted by mini-css-extract-plugin
export default {"container":"UserCard_container__8UZzS","blockButton":"UserCard_blockButton__lf6LS","cardDescription":"UserCard_cardDescription__2oWFp"};